import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EsraPipingAPIClient, BranchTableViewModel } from 'src/app/shared/models/autogenerated-piping';
import { faXmark, faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-branch-table-selector-modal',
  templateUrl: './branch-table-selector-modal.component.html',
  styleUrls: ['./branch-table-selector-modal.component.scss'],
  standalone: false
})
export class BranchTableSelectorModalComponent implements OnInit {
  allBranchTables: BranchTableViewModel[] = [];
  filteredBranchTables: BranchTableViewModel[] = [];
  selectedTables: BranchTableViewModel[] = [];
  searchText = '';

  // Icons
  faXmark = faXmark;
  faCheckCircle = faCheckCircle;
  faCircle = faCircle;

  constructor(
    public dialogRef: MatDialogRef<BranchTableSelectorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { excludeIds: string[] },
    private esraApiClient: EsraPipingAPIClient
  ) {}

  ngOnInit(): void {
    this.loadBranchTables();
  }

  loadBranchTables(): void {
    // Load all branch tables
    this.esraApiClient.getCurrentBranchTablesByPageNumberAndNumberOfResults(0, 1000, '').subscribe(result => {
      // Filter out already selected tables
      this.allBranchTables = result.results.filter(table =>
        !this.data.excludeIds.includes(table.branchTableId)
      );
      this.filteredBranchTables = [...this.allBranchTables];
    });
  }

  filterBranchTables(): void {
    const searchLower = this.searchText.toLowerCase();
    this.filteredBranchTables = this.allBranchTables.filter(table =>
      table.name.toLowerCase().includes(searchLower)
    );
  }

  toggleSelection(table: BranchTableViewModel): void {
    const index = this.selectedTables.findIndex(t => t.branchTableId === table.branchTableId);
    if (index > -1) {
      this.selectedTables.splice(index, 1);
    } else {
      this.selectedTables.push(table);
    }
  }

  isSelected(tableId: string): boolean {
    return this.selectedTables.some(t => t.branchTableId === tableId);
  }

  confirmSelection(): void {
    this.dialogRef.close(this.selectedTables);
  }

  close(): void {
    this.dialogRef.close();
  }
}
